// src/pages/AdminArtistQuotesPage.jsx
import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { useNavigate } from "react-router-dom";
import ArtistQuoteForm from "../components/ArtistQuoteForm";
import CotationAssistPanel from "../components/CotationAssistPanel";
import { useAuth } from "../context/AuthContext"; // ✅ au lieu de useSession

export default function AdminArtistQuotesPage() {
  const { session, user, loading } = useAuth(); // ✅ source unique
  const navigate = useNavigate();
  const [authorized, setAuthorized] = useState(null);
  const [prefill, setPrefill] = useState(null);

  useEffect(() => {
    // Tant que l’auth se charge, on attend.
    if (loading) return;

    console.log("🧠 Auth state:", { hasSession: !!session, uid: user?.id });

    const uid = user?.id || session?.user?.id;

    // Pas connecté → pas autorisé
    if (!uid) {
      setAuthorized(false);
      return;
    }

    let cancelled = false;

    async function checkAccess() {
      console.log("🔐 Vérif accès admin pour :", uid);

      const { data, error } = await supabase
        .from("profiles")
        .select("id, role")
        .eq("id", uid)
        .maybeSingle();

      console.log("✅ Résultat Supabase:", { data, error });

      if (cancelled) return;

      const role = String(data?.role || "").toLowerCase();
      // Phase 1 : accès team + admin.
      if (error || !data || !["admin", "team"].includes(role)) {
        setAuthorized(false);
      } else {
        setAuthorized(true);
      }
    }

    checkAccess();

    return () => {
      cancelled = true;
    };
  }, [loading, session, user?.id]);

  useEffect(() => {
    if (authorized === false) {
      navigate("/unauthorized", { replace: true });
    }
  }, [authorized, navigate]);

  if (loading || authorized === null) {
    return <p>Vérification des autorisations...</p>;
  }
  if (authorized === false) return null;

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">
        Administration des cotes artistes
      </h1>
      <CotationAssistPanel onPrefill={setPrefill} />
      <ArtistQuoteForm prefill={prefill} />
    </div>
  );
}
